export const SHOW_REQUEST_FAILED_MESSAGE = 'errors/SHOW_REQUEST_FAILED_MESSAGE'
export const LOG_REQUEST_FAILED = 'errors/LOG_REQUEST_FAILED'
export const HIDE_LOGGED_OUT_MESSAGE = 'errors/HIDE_LOGGED_OUT_MESSAGE'
export const SHOW_NO_MERCHANTS_MESSAGE = 'errors/SHOW_NO_MERCHANTS_MESSAGE'
export const SHOW_ERROR_PAGE = 'errors/SHOW_ERROR_PAGE'
